import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html',
  styleUrls: ['./view-pdf.component.css']
})
export class ViewPdfComponent implements OnInit {
  pdfUrl:any;
  title:any = "New Doc"
  constructor(private router:Router) { }

  ngOnInit(): void {
    this.pdfUrl = JSON.parse(localStorage.getItem('currentPdfUrl'));
  }
  navigateToChaperPage(){
    this.router.navigate([`selfLearn-V2/documents`]);
  }

}
